var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{attrs:{"open-delay":"50"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-icon',{attrs:{"color":hover ? 'black' : 'grey',"title":_vm.subscription,"medium":""},domProps:{"textContent":_vm._s('mdi-plus')},on:{"click":_vm.eventClick}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }